import React from 'react';
import Input from '../../components/Forms/Input';
import Button from '../../components/Forms/Button';
import Error from '../../components/Helper/Error';
import useForm from '../../hooks/useForm';
import { USER_POST } from '../../services/api';
import { UserContext } from '../../context/UserContext';
import useFetch from '../../hooks/useFetch';
import Head from '../../components/Helper/Head';

const LoginCreate = () => {
  const username = useForm();
  const email = useForm('email');
  const password = useForm();

  const { userLogin } = React.useContext(UserContext);
  const { loading, error, request } = useFetch();

  async function handleSubmit(e) {
    e.preventDefault();

    const { url, options } = USER_POST({
      username: username.value,
      email: email.value,
      password: password.value,
    });

    const { response } = await request(url, options);
    if (response.ok) userLogin(username.value, password.value);
  }

  return (
    <section className="animeLeft">
      <Head title="Crie sua conta" />
      <h1 className="title">Cadastre-se</h1>
      <form onSubmit={handleSubmit}>
        <Input label="Usuário" type="text" name="username" {...username} />
        <Input label="E-mail" type="text" name="email" {...email} />
        <Input label="Senha" type="password" name="password" {...password} />
        {loading ? (
          <Button disabled>Cadastrando...</Button>
        ) : (
          <Button>Cadastrar</Button>
        )}
        <Error error={error} style={{ marginTop: '1rem' }} />
      </form>
    </section>
  );
};

export default LoginCreate;
